import React from "react";
import { Activity } from "lucide-react";
import { getActivityIconStyle } from "../../../../utils/styleUtils";

const ActivityFeed = ({ styles, text, language, recentActivities, screenSize }) => {
  return (
    <div style={styles.activityCard}>
      <h3 style={styles.cardTitle}>
        <Activity size={screenSize.isMobile ? 18 : 20} />
        {text[language].recentActivity}
      </h3>
      <div style={styles.activityFeed}>
        {Array.isArray(recentActivities) && recentActivities.length > 0 ? (
          recentActivities.map((activity, index) => {
            const iconStyle = getActivityIconStyle(activity.type);
            return (
              <div key={index} style={styles.activityItem}>
                <div
                  style={{
                    ...styles.activityIcon,
                    background: iconStyle.background,
                    color: iconStyle.color,
                  }}
                >
                  <Activity size={screenSize.isMobile ? 14 : 16} />
                </div>
                <div style={styles.activityContent}>
                  <p style={styles.activityText}>{activity.action}</p>
                  <p style={styles.activityTime}>
                    {activity.time} • {activity.user}
                  </p>
                </div>
              </div>
            );
          })
        ) : (
          <p
            style={{
              color: language === "ar" ? "rgba(255,255,255,0.6)" : "#888",
              fontSize: 14,
              textAlign: language === "ar" ? "right" : "left",
              padding: "20px",
            }}
          >
            {text[language].noActivities}
          </p>
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;